const modals = {
  printData: [],
};
export default modals;
